/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum EventLogMessageResponseEventLogActionEnum {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
}
